export enum SocialNetworks {
  Instagram = 'instagram',
  YouTube = 'youtube',
  TikTok = 'tiktok',
}
